import { useSetFlyItem } from "@/shared/atoms/useFlyItem";

export const generateUUID = () => {
  if (crypto?.randomUUID) {
    return crypto.randomUUID();
  }

  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

function getCenter(el: HTMLElement) {
  const rect = el.getBoundingClientRect();
  return {
    x: rect.left + rect.width / 2,
    y: rect.top + rect.height / 2,
    width: rect.width,
    height: rect.height,
  };
}

const clamp = (value: number, min: number, max: number) =>
  Math.min(max, Math.max(min, value));

const useAnimateProductToCard = () => {
  const setFlyItem = useSetFlyItem();

  return (productId: number, imageSrc: string, enabled = true) => {
    const productEl = document.getElementById(`product-${productId}`);
    const cartEl = document.getElementById("kiosk-cart");

    if (!productEl || !cartEl) return;

    const product = getCenter(productEl);
    const cart = getCenter(cartEl);

    const startSize = clamp(
      Math.min(product.width, product.height) * 0.55,
      96,
      200,
    );
    const endSize = clamp(cart.height * 0.85, 64, 112);

    setFlyItem({
      id: generateUUID(),
      src: imageSrc,
      startX: product.x,
      startY: product.y,
      endX: cart.x,
      endY: cart.y,
      startSize,
      endSize,
      enabled,
    });
  };
};

export default useAnimateProductToCard;
